module.exports = __webpack_public_path__ + "img/Certificate_9.bc8f6010.jpg";